<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">
        <div>
            <h2>Draft Boards</h2>
        </div>
    
        <div class="bottom-padding">
            Show boards from:
            <b-form-select style='width: auto' class="form-control" v-model="selectedUserID" :options='usersListOptions' @change='changeSelectedUser()'/>
        </div>

        <board-search-results :boards='boardsArray' :items-per-page='itemsPerPage' :current-page-number="this.initialPageNum" :total-results='totalResults' :on-go-to-page="this.goToPage" />

        <help-us-button/>
        <mail-chimp-signup/>
    </b-container>
</template>

<script>
/* eslint-disable handle-callback-err */
import dataService from '../mixins/dataService.js'
import urlsService from '../mixins/urlsService'
import utilityService from '../mixins/utilityService'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import boardSearchResults from './BoardSearchResults.vue'
import cfg from '../config/config.js'

export default {
    mixins: [dataService, urlsService, utilityService],
    data() {
        return {
            selectedUserID: 0,
            usersListOptions: [],
            itemsPerPage: 0,
            initialPageNum: 0,
            boardsArray: [],
            totalResults: 0,
            currentUserName: '',
            boardId: 0
        }
    },
    methods: {

        generateNumericOptionsList(defaultPrompt, defaultValue, numericValuesArray) {
            let options = []
            options.push({ text: defaultPrompt, value: defaultValue })
            for (let c=0; c<numericValuesArray.length; c++) {
                let val = numericValuesArray[c]
                options.push({ text: val + '', value: val })
            }
            return options
        },

        getCurrentUserListOption() {
            return this.usersListOptions.find(c => c.value === this.selectedUserId)
        },

        goToPage(pageNumber) {
            let q = this.getCurrentQuerystringCopy()  // vue router won't pick up changes to the original object; a copy must be made
            q.page = pageNumber + ''
            this.$router.replace({ query: q }).catch(err => {})
            this.initializeComponent()
        },

        getCurrentQuerystringCopy() {
            let q = Object.assign({}, this.$route.query) // vue router won't pick up changes to the original object; a copy must be made
            if (!q.page) {
                q.page = '0'
            }
            return q
        },

        initializeComponent() {
            // console.log('in BoardSearch initializeComponent()')
            this.itemsPerPage = cfg.config.boardResultsPerPage
            this.initialPageNum = this.$route.query.page ? Number.parseInt(this.$route.query.page) : 0
            if (this.usersListOptions.length === 0) {
                this.getUsersWithBoards().then(resp => {
                    this.usersListOptions = []
                    this.usersListOptions.push({ text: 'Everyone', value: 0 })
                    for (let c=0; c < resp.data.length; c++) {
                        let displayUser = resp.data[c]
                        this.usersListOptions.push({ text: displayUser.Name, value: displayUser.UserID })
                    }
                    this.loadBoardsForSelectedUser()
                    // this.currentUserName = this.getCurrentUserListOption().text
                })
            }
            else {
                this.loadBoardsForSelectedUser()
                // this.currentUserName = this.getCurrentUserListOption().text
            }
        },

        changeSelectedUser() {
            this.initialPageNum = 0
            this.loadBoardsForSelectedUser()
        },

        loadBoardsForSelectedUser() {
            // console.log('in loadBoardsForSelectedUser, userID:' + userID)

            let startingResult = this.calculateCurrentStartingResult()
            // console.log('in loadBoardsForSelectedUser, userID:' + this.selectedUserID + ', startingResult: ' + startingResult)
            this.getBoards(this.selectedUserID, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.boardsArray = resp.data.BoardsList
            })
        },

        calculateCurrentStartingResult() {
            return (this.initialPageNum * this.itemsPerPage) + 1 // paged pattern functions expect a startingResult that is 1-based, but maintained in Vue component state as 0-based
        }
    },

    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        boardSearchResults: boardSearchResults
    },

    watch: {
    },

    computed: {
    },

    created() {
        this.$store.commit('setPageTitle', 'Draft Boards')
        let initialPage = this.$route.query.page
        if (!initialPage) {
            initialPage = 0
        }
        this.goToPage(initialPage) // this will add any missing querystring parameters with default values
        this.initializeComponent()
    }
}
</script>

<style scoped>
    .bold-prompt {
        font-weight: bold;
    }
    .input-larger-text {
        font-size: 1.75rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/BoardSearch.vue